import * as Yup from 'yup';

const schema = Yup.object().shape({
  descricao: Yup.string().required('Valor requerido'),
});

export default schema;
